import { useRef, useEffect } from 'react';

/**
 * Hook to track previous value of a variable
 * @param value - Current value to track
 * @returns Previous value
 */
export const usePrevious = <T>(value: T): T | undefined => {
  const ref = useRef<T>();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};

